import {asyncActionGenerator, plainActionGenerator} from 'utils';

export const analyticalNumbersAsyncActions = asyncActionGenerator('analytics');
export const videoAnalyticalNumbersAsyncActions = asyncActionGenerator('video_analytics');
export const sessionVideosAsyncActions = asyncActionGenerator('session_videos');
export const getTrailersAsyncActions = asyncActionGenerator('GET_TRAILER')
export const getTrailerSessionNumbersAsynction = asyncActionGenerator('TRAILER_ANALYTICS');
export const getSpecificTrailerAnalyticsAsyncActions = asyncActionGenerator('GET_SPECIFIC_TRAILER');